// FeaturedProjects.jsx
import React, { useState, useEffect } from 'react';
import './FeaturedProjects.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import featuredImage from '../../images/team-marketing-services.jpg';
import Button from '../Button/Button';
import { projectsData } from '../../utils';

const FeaturedProjects = ({ showMore, sliceCount }) => {
  const [activeCategory, setActiveCategory] = useState('ALL');
  
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);


  // Categories for filter tabs
  const categories = ['ALL', 'UX UI Design', 'Web Development', 'Digital Marketing'];

  // Filter projects based on active category
  const filteredProjects = activeCategory === 'ALL' 
    ? (showMore ? projectsData.slice(0, 3) : projectsData )
    : projectsData.filter(project => project.category === activeCategory);

  return (
    <section className="featured-projects">
      <div className="featured-projects__container">
        <div className="featured-projects__header">
          <div className="featured-projects__badge" data-aos="fade-up">
            Our Projects <span className="featured-projects__badge-icon">↗</span>
          </div>
          <h2 className="featured-projects__title" data-aos="fade-up" data-aos-delay="100">
            Our Featured Projects
          </h2>
          <p className="featured-projects__subtitle" data-aos="fade-up" data-aos-delay="200">
          Bringing Brands to Life — One Strategy at a Time <br />
          At Oma Media Space Limited, we don't just talk strategy — we deliver it. Our portfolio is a reflection of the brands we've helped grow, transform, and amplify across the digital space. From social media turnarounds to stunning websites and result-driven ad campaigns, our work speaks for itself.

          </p>
        </div>


        {
          !showMore &&
            <div className="featured-projects__tabs" data-aos="fade-up" data-aos-delay="300">
              {categories.map((category, index) => (
                <button
                  key={index}
                  className={`featured-projects__tab ${activeCategory === category ? 'featured-projects__tab--active' : ''}`}
                  onClick={() => setActiveCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
        }

        <div className="featured-projects__grid">
          {filteredProjects.map(project => (
            <div 
              className="featured-projects__card" 
              key={project.id}
              data-aos="fade-up"
              data-aos-delay={`${project.id * 100}`}
            >
              <div className="featured-projects__image-container">
                <img
                  src={project.image} 
                  alt={project.title} 
                  className="featured-projects__image" 
                />
              </div>
              <div className="featured-projects__content">
                <h3 className="featured-projects__card-title">{project.title}</h3>
                <p className="featured-projects__card-description">{project.description}</p>
                <a href={project.link} className="featured-projects__view-more" target='_blank'>
                  Details <span className="featured-projects__arrow">→</span>
                </a>
              </div>
            </div>
          ))}
        </div>

        {
          showMore &&
          <div className="featured-projects__more-container" data-aos="fade-up">
            <Button variant="primary" text="More Project" url="/works" />
          </div>
        }
      </div>
    </section>
  );
};

export default FeaturedProjects;
















// // FeaturedProjects.jsx
// import React, { useState, useEffect } from 'react';
// import './FeaturedProjects.css';
// import AOS from 'aos';
// import 'aos/dist/aos.css';
// import featuredImage from '../../images/team-marketing-services.jpg';
// import Button from '../Button/Button';
// import { projectsData } from '../../utils';

// const FeaturedProjects = ({ showMore, sliceCount }) => {
//   const [activeCategory, setActiveCategory] = useState('ALL');
  
//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//       once: true,
//     });
//   }, []);


//   // Categories for filter tabs
//   const categories = ['ALL', 'UX UI Design', 'Web Development', 'Digital Marketing'];

//   // Filter projects based on active category
//   const filteredProjects = activeCategory === 'ALL' 
//     ? projectsData 
//     : projectsData.filter(project => project.category === activeCategory);

//   return (
//     <section className="featured-projects">
//       <div className="featured-projects__container">
//         <div className="featured-projects__header">
//           <div className="featured-projects__badge" data-aos="fade-up">
//             Our Projects <span className="featured-projects__badge-icon">↗</span>
//           </div>
//           <h2 className="featured-projects__title" data-aos="fade-up" data-aos-delay="100">
//             Our Featured Projects
//           </h2>
//           <p className="featured-projects__subtitle" data-aos="fade-up" data-aos-delay="200">
//           Bringing Brands to Life — One Strategy at a Time <br />
//           At Oma Media Space Limited, we don't just talk strategy — we deliver it. Our portfolio is a reflection of the brands we've helped grow, transform, and amplify across the digital space. From social media turnarounds to stunning websites and result-driven ad campaigns, our work speaks for itself.

//           </p>
//         </div>

//         <div className="featured-projects__tabs" data-aos="fade-up" data-aos-delay="300">
//           {categories.map((category, index) => (
//             <button
//               key={index}
//               className={`featured-projects__tab ${activeCategory === category ? 'featured-projects__tab--active' : ''}`}
//               onClick={() => setActiveCategory(category)}
//             >
//               {category}
//             </button>
//           ))}
//         </div>

//         <div className="featured-projects__grid">
//           {filteredProjects.map(project => (
//             <div 
//               className="featured-projects__card" 
//               key={project.id}
//               data-aos="fade-up"
//               data-aos-delay={`${project.id * 100}`}
//             >
//               <div className="featured-projects__image-container">
//                 <img
//                   src={project.image} 
//                   alt={project.title} 
//                   className="featured-projects__image" 
//                 />
//               </div>
//               <div className="featured-projects__content">
//                 <h3 className="featured-projects__card-title">{project.title}</h3>
//                 <p className="featured-projects__card-description">{project.description}</p>
//                 <a href={project.link} className="featured-projects__view-more" target='_blank'>
//                   Details <span className="featured-projects__arrow">→</span>
//                 </a>
//               </div>
//             </div>
//           ))}
//         </div>

//         {
//           showMore &&
//           <div className="featured-projects__more-container" data-aos="fade-up">
//             <Button variant="primary" text="More Project" url="#" />
//           </div>
//         }
//       </div>
//     </section>
//   );
// };

// export default FeaturedProjects;